export const FETCH_CUTTING_REPORT_ENTRY_HEADER_REQUEST = 'FETCH_CUTTING_REPORT_ENTRY_HEADER_REQUEST';
export const FETCH_CUTTING_REPORT_ENTRY_HEADER_SUCCESS = 'FETCH_CUTTING_REPORT_ENTRY_HEADER_SUCCESS';
export const FETCH_CUTTING_REPORT_ENTRY_HEADER_FAILURE = 'FETCH_CUTTING_REPORT_ENTRY_HEADER_FAILURE';

export const FETCH_CUTTING_REPORT_HEADER_REQUEST = 'FETCH_CUTTING_REPORT_HEADER_REQUEST';
export const FETCH_CUTTING_REPORT_HEADER_SUCCESS = 'FETCH_CUTTING_REPORT_HEADER_SUCCESS';
export const FETCH_CUTTING_REPORT_HEADER_FAILURE = 'FETCH_CUTTING_REPORT_HEADER_FAILURE';

export const FETCH_CUTTING_REPORT_PRINT_REQUEST = 'FETCH_CUTTING_REPORT_PRINT_REQUEST';
export const FETCH_CUTTING_REPORT_PRINT_SUCCESS = 'FETCH_CUTTING_REPORT_PRINT_SUCCESS';
export const FETCH_CUTTING_REPORT_PRINT_FAILURE = 'FETCH_CUTTING_REPORT_PRINT_FAILURE';

export const CREATE_CUTTING_REPORT_PRINT_REQUEST = 'CREATE_CUTTING_REPORT_PRINT_REQUEST';
export const CREATE_CUTTING_REPORT_PRINT_SUCCESS = 'CREATE_CUTTING_REPORT_PRINT_SUCCESS';
export const CREATE_CUTTING_REPORT_PRINT_FAILURE = 'CREATE_CUTTING_REPORT_PRINT_FAILURE';

export const CREATE_USER_FORM_CUTTING_REPORTS = 'CREATE_USER_FORM_CUTTING_REPORTS';

export const CREATE_CUTTING_REPORT_PRINT_DATA = 'CREATE_CUTTING_REPORT_PRINT_DATA';

export const NAVIGATE_CUTTING_REPORTS_DEFAULT = 'NAVIGATE_CUTTING_REPORTS_DEFAULT';
export const NAVIGATE_CUTTING_REPORTS_DETAILS = 'NAVIGATE_CUTTING_REPORTS_DETAILS';
export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';


export const NAVIGATE_CUTTING_REPORT_PRINT = 'NAVIGATE_CUTTING_REPORT_PRINT';

export const CUTTING_REPORT_PRINT_REQUEST = 'CUTTING_REPORT_PRINT_REQUEST';
export const CUTTING_REPORT_PRINT_SUCCESS = 'CUTTING_REPORT_PRINT_SUCCESS';
export const CUTTING_REPORT_PRINT_FAILURE = 'CUTTING_REPORT_PRINT_FAILURE';